import { PropsWithChildren } from 'react';

export enum CardEmphasis {
  'Orange' = 'orange',
  'Blue' = 'blue',
  'Green' = 'green',
  'Red' = 'red',
}

export interface CardProps extends PropsWithChildren {
  emphasis?: CardEmphasis;
  className?: string;
}
